//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObjectCollection.js";
import "../CAM/CAM.InspectionSetup.js";
let d=[[],[[["sid"],"FindObject",{R_:{found:"CAM.InspectionGroup"}},1,0],[["parent_group","type_name","subtype_name","use_default_name","new_program_name"],"CreateProgram",{R_:{new_program:"CAM.InspectionGroup"}},5,0],[["parent_group","type_name","subtype_name","use_default_name","new_method_name"],"CreateMethod",{R_:{new_method:"CAM.InspectionGroup"}},5,0],[["parent_group","type_name","subtype_name","use_default_name","new_tool_name"],"CreateTool",{R_:{new_tool:"CAM.InspectionGroup"}},5,0],[["param"],"CreateProgramOrderGroupBuilder",{R_:{builder:"CAM.ProgramOrderGroupBuilder"}},1,0],[["param"],"CreateInspectionMethodBuilder",{R_:{builder:"CAM.InspectionMethodBuilder"}},1,0],[["param"],"CreateProbeToolBuilder",{R_:{builder:"CAM.ProbeToolBuilder"}},1,0],[["param"],"CreateInspectionProbeToolBuilder",{R_:{builder:"CAM.InspectionProbeToolBuilder"}},1,0],[["param"],"CreateMachineGroupBuilder",{R_:{builder:"CAM.MachineGroupBuilder"}},1,0],[["param"],"CreateMachineTurretGroupBuilder",{R_:{builder:"CAM.MachineTurretGroupBuilder"}},1,0],[["param"],"CreateMachinePocketGroupBuilder",{R_:{builder:"CAM.MachinePocketGroupBuilder"}},1,0]],[]];
SPLM.CAM.InspectionGroupCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.CAM.InspectionGroupCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;